import { createSlice } from "@reduxjs/toolkit";

interface TabManagementState {
	activeSectionId: string;
	currentStep: string; // "indoor" | "outdoor"
}

const initialState: TabManagementState = {
	activeSectionId: "",
	currentStep: "",
};

const tabManagementSlice = createSlice({
	name: "tabManagement",
	initialState,
	reducers: {
		setActiveSection: (state, action) => {
			state.activeSectionId = action.payload;
		},
		setCurrentStep: (state, action) => {
			state.currentStep = action.payload;
		},
		resetTabManagement: state => {
			state.activeSectionId = "";
			state.currentStep = "";
		},
	},
});

export const { setActiveSection, setCurrentStep, resetTabManagement } = tabManagementSlice.actions;
export default tabManagementSlice.reducer;
